module.exports = __webpack_public_path__ + "img/gifntext 3-min.820f555a.gif";